import React, { useEffect, useState, createContext, useContext, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { refresh } from './modules/User';
import { baseUrl } from '../../shared';

import AuthContext from './modules/AuthContext';
import APIUnavailable from '../pages/APIUnavailable';

function AuthProvider({ children }) {
    const winPath = useLocation();
    const isAuthenticated = useRef(false);

    const [apiState, setApiState] = useState('available');
    const [user, setUser] = useState();

    if (!localStorage.getItem('lastvisit')) {
        localStorage.setItem('lastvisit', JSON.stringify({}))
    }

    const getCurrentUser = async () => {
        refresh()
            .then(response => response.json())
            .then((responseInfo) => {
                isAuthenticated.current = true;
                setUser(responseInfo.data || null);
                return;
            })
            .catch((err) => {
                setApiState('unavailable');
            });
    };

    useEffect(() => {
        getCurrentUser();
    }, [winPath.pathname]);

    return (
        <>
            {isAuthenticated.current && <AuthContext.Provider value={{refresh, user}}>{children}</AuthContext.Provider>}
            {apiState == 'unavailable' && <APIUnavailable/>}
        </>
    );
};

export default AuthProvider;